import React from "react";
import {Control, Controller, FieldPath, FieldValues} from "react-hook-form";
import {usePublicTranslations} from "@i18n/i18nUtils";

type ConsentValue = "true" | "false";

interface PrivacyFieldProps<T extends FieldValues> {
    control: Control<T>;
    name: FieldPath<T>;
    title?: string;
    text: string;
    disabled?: boolean;
    error?: string;
    withDivider?: boolean;
    agreeLabel?: string;
    declineLabel?: string;
    singleOption?: boolean;
}

export function PrivacyField<T extends FieldValues>(props: PrivacyFieldProps<T>) {

    const {control, name, title, text, disabled, error, agreeLabel, declineLabel, singleOption = false, withDivider = true} = props;

    const {t} = usePublicTranslations();

    return (
        <div className="gdprRow">
            {!!title &&
                <strong className={"tp-s bold"}>{title}</strong>
            }
            {!!text &&
                <p className="gdprRow__text tp-xs" dangerouslySetInnerHTML={{__html: text }}/>
            }

            <div className="gdprRow__choices">
                <Controller
                    control={control}
                    name={name}
                    render={({ field }) => {
                        const value = (field.value ?? "") as ConsentValue | "";

                        return (
                            <>
                                <label className="prettyCheck">
                                    <input
                                        className="prettyCheck__input"
                                        type="radio"
                                        name={field.name}
                                        value="true"
                                        checked={value === "true"}
                                        onChange={() => field.onChange("true")}
                                        disabled={disabled}
                                    />
                                    <span className="prettyCheck__box" aria-hidden="true" />
                                    <span className="prettyCheck__label tp-s">{agreeLabel ?? t("public.onboard.form.labels.agree")}</span>
                                </label>

                                {!singleOption &&
                                    <label className="prettyCheck">
                                        <input
                                            className="prettyCheck__input"
                                            type="radio"
                                            name={field.name}
                                            value="false"
                                            checked={value === "false"}
                                            onChange={() => field.onChange("false")}
                                            disabled={disabled}
                                        />
                                        <span className="prettyCheck__box" aria-hidden="true" />
                                        <span className="prettyCheck__label tp-s">{declineLabel ?? t("public.onboard.form.labels.decline")}</span>
                                    </label>
                                }
                            </>
                        );
                    }}
                />
            </div>


            {error ? <div className="gdprRow__error form__field__error">{error}</div> : null}
            {withDivider && <div className="gdprRow__divider"/>}
        </div>
    );
}
